"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Snackbars = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Snackbars, _Component);

  var _super = _createSuper(Snackbars);

  function Snackbars(props, context) {
    var _this;

    (0, _classCallCheck2.default)(this, Snackbars);
    _this = _super.call(this, props, context); // In case of new construction (when losing application main context) => dismiss of all previous notifications

    props.actions.dismissAll();
    _this.handleAnimationEnd = _this.handleAnimationEnd.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDismiss = _this.handleDismiss.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Snackbars, [{
    key: "handleAnimationEnd",
    value: function handleAnimationEnd(notificationId) {
      var _this2 = this;

      return function (event) {
        if (event.animationName === 'fade-out-snackbar') {
          _this2.dismiss(notificationId);
        }
      };
    }
  }, {
    key: "handleDismiss",
    value: function handleDismiss(notificationId) {
      var _this3 = this;

      return function (event) {
        event.preventDefault();
        event.stopPropagation();

        _this3.dismiss(notificationId);
      };
    }
  }, {
    key: "dismiss",
    value: function dismiss(notificationId) {
      this.props.actions.dismiss(notificationId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var snackbars = this.props.notifications.map(function (notification) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "snackbar-container",
          onAnimationEnd: _this4.handleAnimationEnd(notification.id),
          onClick: _this4.handleDismiss(notification.id),
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
            className: "snackbar ".concat(notification.kind),
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: notification.message
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "dismiss",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                icon: "cross"
              })
            })]
          })
        }, notification.id);
      });
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "snackbars-container",
        children: snackbars
      });
    }
  }]);
  return Snackbars;
}(_react.Component);

Snackbars.propTypes = {
  notifications: _propTypes.default.array.isRequired,
  actions: _propTypes.default.object.isRequired
};
var _default = Snackbars;
exports.default = _default;
//# sourceMappingURL=Snackbars.js.map